import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Info } from "lucide-react";

export const PolicyTimeAlert = () => {
  return (
    <Flex gap="30px">
      <Text
        as="div"
        display="flex"
        alignItems="center"
        fontWeight={600}
        fontSize={"20px"}
      >
        Horario
      </Text>
      <Flex
        data-testid="policy-time-alert"
        alignItems="center"
        justifyContent="space-between"
        bgColor={AppColors.BLUE_BACKGROUND_2}
        paddingY="20px"
        paddingX="30px"
        borderRadius="6px"
        maxHeight="41px"
        css={{
          "@media (max-width: 1350px) and (min-width: 1272px)": {
            maxWidth: "500px",
          },
          "@media (max-width: 1414px) and (min-width: 1351px)": {
            maxWidth: "550px",
          },
          "@media (max-width: 1590px) and (min-width: 1415px)": {
            maxWidth: "600px",
          },
          "@media (max-width: 1696px) and (min-width: 1591px)": {
            maxWidth: "600px",
          },
          "@media (max-width: 1920px)": {
            maxWidth: "600px",
          },
        }}
      >
        <Flex alignItems="center" gap="12px">
          <Info />
          <Text
            css={{
              "@media (max-width: 1350px) and (min-width: 1272px)": {
                fontSize: "12px",
              },
              "@media (max-width: 1414px) and (min-width: 1351px)": {
                fontSize: "14px",
              },
              "@media (max-width: 1590px) and (min-width: 1415px)": {
                fontSize: "14px",
              },
              "@media (max-width: 1696px) and (min-width: 1591px)": {
                fontSize: "14px",
              },
              "@media (max-width: 1920px)": {
                fontSize: "16px",
              },
            }}
            fontWeight={500}
          >
            Los horarios elegidos afectan a todos los días de la semana
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
